import { render, staticRenderFns } from "./DetalhesPosto.vue?vue&type=template&id=ee58c34a&"
import script from "./DetalhesPosto.vue?vue&type=script&lang=js&"
export * from "./DetalhesPosto.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesPosto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports